import React, { useEffect, useState } from "react";
import axios from "axios";
// reactstrap components
import {
  Button,
  FormGroup,
  Form,
  Input,
  InputGroupAddon,
  InputGroupText,
  InputGroup,
  Container,
  Row,
  Col,
  Label,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";

// core components
import WhiteNavbar from "components/Navbars/WhiteNavbar";
import { Helmet } from "react-helmet-async";
import { BiCheck } from "react-icons/bi";
import { BsFillPersonFill } from "react-icons/bs";
import { AiOutlineMail, AiTwotonePhone } from "react-icons/ai";
import Footer from "components/Footers/Footer";
import { IoLocationSharp, IoMail } from "react-icons/io5";
import { FaPhone } from "react-icons/fa";
import { KVKK_TEXT } from "content/legal/KvkkText";
import { ACIK_RIZA_TEXT } from "content/legal/AcikRizaMetniText";
import ReCAPTCHA from "react-google-recaptcha";

function ContactUs() {
  const [nameFocus, setNameFocus] = React.useState(false);
  const [emailFocus, setEmailFocus] = React.useState(false);
  const [numberFocus, setNumberFocus] = React.useState(false);

  const navigate = useNavigate();
  const location = useLocation();
  const receivedData = location.state?.data || {};
  console.log(receivedData);

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: location.state?.data
      ? `I want to get a special offer for ${receivedData?.id} number ${receivedData?.name} ${receivedData?.type}. Please contact me.(You can add extra information)`
      : "",
  });

  // KVKK state
  const [kvkkAccepted, setKvkkAccepted] = useState(false);
  const [kvkkError, setKvkkError] = useState(false);
  const [kvkkModalOpen, setKvkkModalOpen] = useState(false);
  const [acikRizaAccepted, setAcikRizaAccepted] = useState(false);
  const [acikRizaError, setAcikRizaError] = useState(false);
  const [acikRizaModalOpen, setAcikRizaModalOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  // reCAPTCHA state
  const [captchaToken, setCaptchaToken] = useState(null);
  const [captchaError, setCaptchaError] = useState(false);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData((prevFormData) => ({ ...prevFormData, [name]: value }));
  };

  const toggleKvkkModal = () => setKvkkModalOpen((v) => !v);
  const toggleAcikRizaModal = () => setAcikRizaModalOpen((v) => !v);

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!kvkkAccepted || !acikRizaAccepted) {
      setKvkkError(!kvkkAccepted);
      setAcikRizaError(!acikRizaAccepted);
      return;
    }

    if (!captchaToken) {
      setCaptchaError(true);
      return;
    }

    try {
      await axios.post(
        "https://eksiogluhukukofisi.pythonanywhere.com/api/contact/",
        formData,
      );

      setFormData({
        name: "",
        email: "",
        phone: "",
        message: "",
      });

      setKvkkAccepted(false);
      setKvkkError(false);
      setAcikRizaAccepted(false);
      setAcikRizaError(false);

      alert(
        "Mesajınız iletilmiştir. En kısa zamanda sizlere dönüş yapılacaktır.",
      );
    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  React.useEffect(() => {
    document.body.classList.add("contact-page");
    window.scrollTo(0, 0);
    document.body.scrollTop = 0;
    return function cleanup() {
      document.body.classList.remove("contact-page");
      document.body.classList.remove("sidebar-collapse");
    };
  }, []);

  useEffect(() => {
    const onResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    const targetLink = document.querySelector('a[data-gt-lang="tr"]');

    if (targetLink) {
      targetLink.click();
      const imgElement = document.querySelector(".gt-current-lang img");
      const newImgSrc = "https://cdn.gtranslate.net/flags/32/tr.png";
      console.log(imgElement);
      imgElement.src = newImgSrc;
      imgElement.width = "32";
      imgElement.height = "32";
    }
  }, []);

  const kvkkLines = (KVKK_TEXT || "").trim().split("\n");

  return (
    <>
      <Helmet>
        <title>İLETİŞİM | EKŞİOĞLU HUKUK</title>
        <meta name="theme-color" content="#000000" />
        <meta
          name="description"
          content="EKŞİOĞLU HUKUK sizin ihtiyaçlarınızı bilir ve en uygun çözümleri sunar"
          data-rh="true"
        />
        <link
          rel="canonical"
          href="https://www.eksiogluhukukofisi.com/iletisim"
        />
        <meta property="og:title" content="İLETİŞİM | EKŞİOĞLU HUKUK" />
        <meta property="og:type" content="website" />
        <meta property="og:description" content="EKŞİOĞLU HUKUK" />
        <meta
          property="og:image"
          content="https://www.eksiogluhukukofisi.com/static/media/eksiogluWhiteLogo.e14b5e9c41e5271d670c.png"
        />
        <meta
          property="og:url"
          content="https://www.eksiogluhukukofisi.com/iletisim"
        />
      </Helmet>
      <WhiteNavbar navbarSelection={"contact-us"} />
      <div className="wrapper font-sans" style={{}}>
        <br />
        <br />
        <div className="main">
          <div className="contact-content">
            <Container>
              <Row>
                <Col className="ml-auto mr-auto" md="5">
                  <h1 style={{ display: "none" }}>
                    EKŞİOĞLU HUKUK Contact Form
                  </h1>
                  <h2 className="title">Bizimle iletişime geçin</h2>
                  <h3 style={{ display: "none" }}>
                    EKŞİOĞLU HUKUK, Get in Touch
                  </h3>
                  <p className="description">
                    Randevu ve bilgi almak için bizimle iletişime geçin. Size en
                    kısa zamanda dönüş yapacağımızdan emin olabilirsiniz.{" "}
                    <br></br>
                    <br></br>
                  </p>
                  <Form id="contact-form" onSubmit={handleSubmit}>
                    <label>İsim</label>
                    <InputGroup
                      className={nameFocus ? "input-group-focus" : ""}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons">
                            <BsFillPersonFill />
                          </i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="name"
                        name="name"
                        required
                        value={formData.name}
                        onChange={handleInputChange}
                        aria-label="Your Name..."
                        autoComplete="name"
                        placeholder="İsminizi giriniz"
                        type="text"
                        onFocus={() => setNameFocus(true)}
                        onBlur={() => setNameFocus(false)}
                      ></Input>
                    </InputGroup>
                    <label>Email</label>
                    <InputGroup
                      className={emailFocus ? "input-group-focus" : ""}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons">
                            <AiOutlineMail />
                          </i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="email"
                        name="email"
                        required
                        value={formData.email}
                        onChange={handleInputChange}
                        aria-label="Email Here..."
                        autoComplete="email"
                        placeholder="Email Adresinizi Giriniz"
                        type="email"
                        onFocus={() => setEmailFocus(true)}
                        onBlur={() => setEmailFocus(false)}
                      ></Input>
                    </InputGroup>
                    <label>Telefon</label>
                    <InputGroup
                      className={numberFocus ? "input-group-focus" : ""}
                    >
                      <InputGroupAddon addonType="prepend">
                        <InputGroupText>
                          <i className="now-ui-icons">
                            <AiTwotonePhone />
                          </i>
                        </InputGroupText>
                      </InputGroupAddon>
                      <Input
                        id="phone"
                        name="phone"
                        required
                        value={formData.phone}
                        onChange={handleInputChange}
                        autoComplete="number"
                        placeholder="Numaranızı giriniz"
                        type="text"
                        onFocus={() => setNumberFocus(true)}
                        onBlur={() => setNumberFocus(false)}
                      ></Input>
                    </InputGroup>
                    <FormGroup>
                      <label htmlFor="message">Mesajınız</label>
                      <Input
                        id="message"
                        name="message"
                        value={formData.message}
                        onChange={handleInputChange}
                        rows="6"
                        type="textarea"
                        placeholder="Mesajınızı Giriniz"
                      ></Input>
                    </FormGroup>

                    {/* KVKK ONAY BLOĞU */}
                    <FormGroup style={{ marginTop: 10 }}>
                      <div
                        style={{
                          padding: "8px 20px",
                          borderRadius: 10,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 10,
                          }}
                        >
                          <Input
                            type="checkbox"
                            id="kvkk"
                            checked={kvkkAccepted}
                            onChange={(e) => {
                              setKvkkAccepted(e.target.checked);
                              if (e.target.checked) setKvkkError(false);
                            }}
                            style={{ marginTop: 4 }}
                          />
                          <Label
                            htmlFor="kvkk"
                            style={{ marginBottom: 0, cursor: "pointer" }}
                          >
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                toggleKvkkModal();
                              }}
                              style={{
                                textDecoration: "underline",
                                textUnderlineOffset: 3,
                                fontWeight: 600,
                                color: kvkkError ? "#dc3545" : "inherit",
                              }}
                            >
                              KVKK Aydınlatma Metni
                            </span>{" "}
                            ’ni okudum ve onaylıyorum.
                          </Label>
                        </div>

                        {kvkkError && (
                          <div
                            style={{
                              color: "#dc3545",
                              marginTop: 6,
                              fontSize: 13,
                              paddingLeft: 28,
                            }}
                          >
                            KVKK metnini onaylamanız gerekir.
                          </div>
                        )}
                      </div>
                    </FormGroup>

                    {/* AÇIK RIZA ONAY BLOĞU */}
                    <FormGroup style={{ marginTop: 10 }}>
                      <div
                        style={{
                          padding: "8px 20px",
                          borderRadius: 10,
                          overflow: "hidden",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 10,
                          }}
                        >
                          <Input
                            type="checkbox"
                            id="acik-riza"
                            checked={acikRizaAccepted}
                            onChange={(e) => {
                              setAcikRizaAccepted(e.target.checked);
                              if (e.target.checked) setAcikRizaError(false);
                            }}
                            style={{ marginTop: 4 }}
                          />
                          <Label
                            htmlFor="acik-riza"
                            style={{ marginBottom: 0, cursor: "pointer" }}
                          >
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                toggleAcikRizaModal();
                              }}
                              style={{
                                textDecoration: "underline",
                                textUnderlineOffset: 3,
                                fontWeight: 600,
                                color: acikRizaError ? "#dc3545" : "inherit",
                              }}
                            >
                              Açık Rıza Metni
                            </span>{" "}
                            ’ni okudum ve onaylıyorum.
                          </Label>
                        </div>

                        {acikRizaError && (
                          <div
                            style={{
                              color: "#dc3545",
                              marginTop: 6,
                              fontSize: 13,
                              paddingLeft: 28,
                            }}
                          >
                            Açık rıza metnini onaylamanız gerekir.
                          </div>
                        )}
                      </div>
                    </FormGroup>

                    {/* reCAPTCHA (Ben robot değilim) */}
                    <FormGroup style={{ marginTop: 10 }}>
                      <div style={{ padding: "8px 20px", borderRadius: 10 }}>
                        <ReCAPTCHA
                          sitekey={process.env.REACT_APP_RECAPTCHA_SITE_KEY}
                          onChange={(token) => {
                            setCaptchaToken(token);
                            setCaptchaError(false);
                          }}
                          onExpired={() => setCaptchaToken(null)}
                        />

                        {captchaError && (
                          <div
                            style={{
                              color: "#dc3545",
                              marginTop: 6,
                              fontSize: 13,
                            }}
                          >
                            Lütfen “Ben robot değilim” doğrulamasını yapın.
                          </div>
                        )}
                      </div>
                    </FormGroup>

                    <div className="submit text-center">
                      <Button
                        className="btn-raised btn-round"
                        color="info"
                        defaultValue="Contact Us"
                        type="submit"
                        onClick={() => {
                          if (!kvkkAccepted) setKvkkError(true);
                          if (!acikRizaAccepted) setAcikRizaError(true);
                          if (!captchaToken) setCaptchaError(true);
                        }}
                      >
                        Gönder
                      </Button>
                    </div>
                  </Form>
                </Col>
                <Col className="ml-auto mr-auto" md="5">
                  <div className="info info-horizontal mt-5">
                    <div className="icon icon-info">
                      <i className="now-ui-icons">
                        <IoLocationSharp size={24} />
                      </i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Adresimiz</h4>
                      <p>
                        Soğanlık Yeni Mah. Aliağa Sok. No:8 K:30 D:159 Bumerang
                        Towers Kartal/İstanbul
                      </p>
                    </div>
                  </div>
                  <div className="info info-horizontal">
                    <div className="icon icon-info">
                      <i className="now-ui-icons">
                        <FaPhone size={24} />
                      </i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Telefon Numaramız</h4>
                      <p>(0216) 949 03 53</p>
                    </div>
                  </div>
                  <div className="info info-horizontal">
                    <div className="icon icon-info">
                      <i className="business_briefcase-24">
                        <IoMail size={24} />
                      </i>
                    </div>
                    <div className="description">
                      <h4 className="info-title">Email Adresimiz</h4>
                      <p>bilgi@eksiogluhukukofisi.com</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </div>

      {/* KVKK MODAL */}
      <Modal
        isOpen={kvkkModalOpen}
        toggle={toggleKvkkModal}
        style={{
          margin: isMobile ? "1.25rem auto" : undefined,
          maxWidth: isMobile ? "92vw" : undefined,
          marginTop: isMobile ? "150px" : "100px",
        }}
        scrollable={false}
      >
        <ModalHeader toggle={toggleKvkkModal}>
          KVKK Aydınlatma Metni
        </ModalHeader>
        <ModalBody
          style={{
            maxHeight: isMobile ? "62vh" : "70vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
              color: "#0F172A",
              fontSize: 14,
            }}
          >
            {kvkkLines.map((rawLine, idx) => {
              const line = rawLine?.replace(/\r/g, "");
              const trimmed = line.trim();

              if (!trimmed) return <div key={idx} style={{ height: 10 }} />;

              const isNumberedHeading = /^\d+\s*\./.test(trimmed);
              const isMainHeading = trimmed === "Kişisel Verilerin Korunması";
              const isHeading = isNumberedHeading || isMainHeading;

              return (
                <p
                  key={idx}
                  style={{
                    marginBottom: 10,
                    marginTop: isHeading ? 18 : 0,
                    fontWeight: isHeading ? 700 : 400,
                  }}
                >
                  {isHeading ? <strong>{trimmed}</strong> : line}
                </p>
              );
            })}
          </div>
          <div style={{ marginTop: 18 }}>
            <Button
              color="info"
              className="btn-raised btn-round w-100"
              onClick={() => {
                setKvkkAccepted(true);
                setKvkkError(false);
                setKvkkModalOpen(false);
              }}
            >
              Okudum, Onaylıyorum
            </Button>
          </div>
        </ModalBody>
        <ModalFooter style={{ display: "none" }} />
      </Modal>

      {/* AÇIK RIZA MODAL */}
      <Modal
        isOpen={acikRizaModalOpen}
        toggle={toggleAcikRizaModal}
        style={{
          margin: isMobile ? "1.25rem auto" : undefined,
          maxWidth: isMobile ? "92vw" : undefined,
          marginTop: isMobile ? "150px" : "100px",
        }}
        scrollable={false}
      >
        <ModalHeader toggle={toggleAcikRizaModal}>Açık Rıza Metni</ModalHeader>
        <ModalBody
          style={{
            maxHeight: isMobile ? "62vh" : "70vh",
            overflowY: "auto",
          }}
        >
          <div
            style={{
              whiteSpace: "pre-wrap",
              lineHeight: 1.7,
              color: "#0F172A",
              fontSize: 14,
            }}
          >
            {ACIK_RIZA_TEXT}
          </div>
          <div style={{ marginTop: 18 }}>
            <Button
              color="info"
              className="btn-raised btn-round w-100"
              onClick={() => {
                setAcikRizaAccepted(true);
                setAcikRizaError(false);
                setAcikRizaModalOpen(false);
              }}
            >
              Okudum, Onaylıyorum
            </Button>
          </div>
        </ModalBody>
        <ModalFooter style={{ display: "none" }} />
      </Modal>
    </>
  );
}

export default ContactUs;
